export const SEVERITY_CHOICES = [
  { name: "CRITICAL", id: "critical" },
  { name: "HIGH", id: "high" },
  { name: "MEDIUM", id: "medium" },
  { name: "LOW", id: "low" },
  { name: "NONE", id: "none" },
];

export const STATUS_CHOICES = [
  { name: "OPEN", id: "open" },
  { name: "PENDING_RELEASE", id: "pending_release" },
  { name: "CLOSED", id: "closed" },
];

export const ADJUDICATION_CATEGORY_CHOICES = [
  { name: "VULNERABLE", id: "vulnerable" },
  { name: "FALSE POSITIVE", id: "false_positive" },
  { name: "CODE NOTE PRESENT", id: "code_not_present" },
  { name: "CODE NOTE REACHBLE", id: "code_not_reachable" },
  { name: "REQUIRES CONFIGURATION", id: "requires_configuration" },
  { name: "REQUIRES DEPENDENCY", id: "requires_dependency" },
  { name: "REQUIRES ENVIRONMENT", id: "requires_environment" },
  { name: "PROTECTED BY COMPILER", id: "protected_by_compiler" },
  { name: "PROTECTED AT RUNTIME", id: "protected_at_runtime" },
  { name: "PROTECTED BY PERIMETER", id: "protected_by_perimeter" },
  {
    name: "PROTECTED BY MITIGATING CONTROL",
    id: "protected_by_mitigating_control",
  },
  { name: "DEPRECATED", id: "deprecated" },
];

export const EMPLOYEE_STATUS_CHOICES = [
  { name: "ACTIVE", id: "active" },
  { name: "SUSPENDED", id: "suspended" },
  { name: "STAGED", id: "staged" },
  { name: "DEPROVISIONED", id: "deprovisioned" },
  { name: "PROVISIONED", id: "provisioned" },
  { name: "RECOVERY", id: "recovery" },
  { name: "LOCKED_OUT", id: "locked_out" },
  { name: "PASSWORD_EXPIRED", id: "password_expired" },
  { name: "REMOVED", id: "removed" },
];

export const RISK_STATUS_CHOICES = [
  { name: "NEW", id: "new" },
  { name: "REJECTED", id: "rejected" },
  { name: "OPEN", id: "open" },
  { name: "CLOSED", id: "closed" },
  { name: "ARCHIVED", id: "archived" },
];

export const RISK_SEVERITY_CHOICES = [
  { name: "CATASTROPHIC", id: "catastrophic" },
  { name: "CRITICAL", id: "critical" },
  { name: "MODERATE", id: "moderate" },
  { name: "NEGLIGIBLE", id: "negligible" },
];

export const RISK_LIKELIHOOD_CHOICES = [
  { name: "FREQUENT", id: "frequent" },
  { name: "LIKELY", id: "likely" },
  { name: "OCCASIONAL", id: "occasional" },
  { name: "SELDOM", id: "seldom" },
  { name: "UNLIKELY", id: "unlikely" },
];

export const RISK_TYPE_CHOICES = [
  { name: "FINANCIAL", id: "financial" },
  { name: "OPERATIONAL", id: "operational" },
  { name: "STRATEGIC", id: "strategic" },
  { name: "COMPLIANCE", id: "compliance" },
  { name: "REPUTATIONAL", id: "reputational" },
];

export const RISK_LEVEL_CHOICES = [
  { name: "EXTREMELY HIGH", id: "extremely_high" }, // Note: backend has typo "extermely"
  { name: "HIGH", id: "high" },
  { name: "MEDIUM", id: "medium" },
  { name: "LOW", id: "low" },
];

export const USER_ROLES = [
  { name: "Global Admin", id: "admin" },
  { name: "CVE Viewer", id: "cve_viewer" },
  { name: "CVE Editor", id: "cve_editor" },
  { name: "CVE Admin", id: "cve_admin" },
  { name: "RMF Viewer", id: "rmf_viewer" },
  { name: "RMF Editor", id: "rmf_editor" },
  { name: "RMF Admin", id: "rmf_admin" },
  { name: "Vector Viewer", id: "vector_viewer" },
  { name: "Vector Editor", id: "vector_editor" },
  { name: "Vector Admin", id: "vector_admin" },
];
